import { useQuery } from '@tanstack/react-query'

export default function useSomtodayInstitutes() {
  return useQuery({
    queryKey: ['somtoday-institutes'],
    queryFn: async () => {
      const response = await fetch('https://api.somtoday.nl/rest/v1/connect/instelling', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })

      if (!response.ok) {
        throw new Error('Failed to fetch Somtoday institutes')
      }

      const data = await response.json()
      return data.instellingen
    }
    ,
  })
}
